export default {
  "ulassa": {
    "name": "Ulassa",
    "cards": [
      {
        "name": "0",
        "path": "/decks/ulassa/0.png"
      },
      {
        "name": "1",
        "path": "/decks/ulassa/1.png"
      },
      {
        "name": "2",
        "path": "/decks/ulassa/2.png"
      },
      {
        "name": "3",
        "path": "/decks/ulassa/3.png"
      },
      {
        "name": "5",
        "path": "/decks/ulassa/5.png"
      },
      {
        "name": "8",
        "path": "/decks/ulassa/8.png"
      },
      {
        "name": "13",
        "path": "/decks/ulassa/13.png"
      },
      {
        "name": "20",
        "path": "/decks/ulassa/20.png"
      },
      {
        "name": "40",
        "path": "/decks/ulassa/40.png"
      },
      {
        "name": "100",
        "path": "/decks/ulassa/100.png"
      },
      {
        "name": "∞",
        "path": "/decks/ulassa/endless.png"
      },
      {
        "name": "?",
        "path": "/decks/ulassa/question.png"
      },
      {
        "name": "Break",
        "path": "/decks/ulassa/break.png"
      }
    ]
  },

  "redbooth": {
    "name": "Redbooth",
    "cards": [
      {
        "name": "0",
        "path": "/decks/redbooth/0.png"
      },
      {
        "name": "1",
        "path": "/decks/redbooth/1.png"
      },
      {
        "name": "2",
        "path": "/decks/redbooth/2.png"
      },
      {
        "name": "3",
        "path": "/decks/redbooth/3.png"
      },
      {
        "name": "5",
        "path": "/decks/redbooth/5.png"
      },
      {
        "name": "8",
        "path": "/decks/redbooth/8.png"
      },
      {
        "name": "13",
        "path": "/decks/redbooth/13.png"
      },
      {
        "name": "20",
        "path": "/decks/redbooth/20.png"
      },
      {
        "name": "40",
        "path": "/decks/redbooth/40.png"
      },
      {
        "name": "100",
        "path": "/decks/redbooth/100.png"
      },
      {
        "name": "∞",
        "path": "/decks/redbooth/endless.png"
      },
      {
        "name": "?",
        "path": "/decks/redbooth/question.png"
      },
      {
        "name": "Break",
        "path": "/decks/redbooth/break-1.png"
      },
      {
        "name": "Break 2",
        "path": "/decks/redbooth/break-2.png"
      }
    ]
  },


}